module.exports = __webpack_public_path__ + "static/img/2.628d0aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/2.png
// module id = 9soJ
// module chunks = 0